import * as Yup from "yup";

export const userSchema = Yup.object({
    user_name: Yup.string().required(" Enter Name"),
    phone_no: Yup.string().matches(/^[6-9]\d{9}$/, "Invalid Number").required("Enter Phone Number"),
    email: Yup.string()
        .email("Enter a valid email address")
        .matches(/^[\w.%+-]+@[A-Za-z0-9.-]+\.com$/, "Email must end with .com")
        .required("Email is required"),
    password: Yup.string().min(6, "Password is too week").required(" Enter Password"),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], "Passwords doesn't match")
        .required('Confirm Password'),
    // role: Yup.string().required(" Select Role"), // static: staff
    designation: Yup.string().required('Select Designation'),
    department: Yup.string().required('Select Department'),
    // profile_image: Yup.mixed().nullable(), // optional
    // designation: Yup.string().required(" Select Designation"),
    // department: Yup.string().required(" Select Department"),
    status: Yup.string().required("Select Status"),
    // password: Yup.string().required(" Enter Password"),
    profile_image: Yup.mixed().nullable(),
});


export const updateUserSchema = Yup.object({
    user_name: Yup.string().required(" Enter Name"),
    phone_no: Yup.string().matches(/^[6-9]\d{9}$/, "Invalid Number").required("Enter Phone Number"),
    email: Yup.string().required(" Enter Email"),
    // confirm_password: Yup.string()
    //     .oneOf([Yup.ref('password'), null], "Passwords doesn't match")
    //     .required('Confirm Password'),
    // role: Yup.string().required(" Select Role"),
    designation: Yup.string().when('role', {
        is: (val) => val === 'admin',
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Select Designation'),
    }),
    department: Yup.string().when('role', {
        is: (val) => val === 'admin',
        then: () => Yup.string().notRequired(),
        otherwise: () => Yup.string().required('Select Department'),
    }),
    // designation: Yup.string().required(" Select Designation"),
    // department: Yup.string().required(" Select Department"),
    status: Yup.string().required("Select Status"),
    profile_image: Yup.mixed().nullable(),
    // password: Yup.string().required(" Enter Password"),
});
